import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { FavouriteServiceParams } from './Favourite.type';

const favouriteService = {
  addFavourite: ({ personId }: FavouriteServiceParams) => {
    return axios.post(getEndpointBase(`favourites/${personId}`));
  },

  deleteFromFavourite: ({ personId }: FavouriteServiceParams) => {
    return axios.delete(getEndpointBase(`favourites/${personId}`));
  },
};

export default favouriteService;
